import Tolls from '../../../../services/toll';

export default {
  props: ['vpData'],
  data() {
    return {
      loading: undefined,
      summaryVP: {},
      origin: {},
      destination: {},
    }
  },
  mounted: function() {
    return this.loading = Tolls.getById(this.vpData.idVP).then(resp => {
      this.summaryVP = resp;
      this.origin.city = resp.origem.substring(0, resp.origem.indexOf(','));
      this.origin.state = resp.origem.substring(resp.origem.indexOf(',') +1, resp.origem.indexOf(',') +4);
      this.destination.city = resp.destino.substring(0, resp.destino.indexOf(','));
      this.destination.state = resp.destino.substring(resp.destino.indexOf(',') +1, resp.destino.indexOf(',') +4);
    }).catch(err => {
      
    });
  },
  methods: {
    closeModal() {
      let close = {
        modal: 'route-vp'
      };
      this.$emit('close', close);
      this.summaryVP = {};
      this.origin = {};
      this.destination = {};
    }
  },
}



// WEBPACK FOOTER //
// ./src/pages/account/aggregate/modal/modal-route-vp.js